import { patentSearch, getCaptcha } from "@/api/search";
const search = {
  state: {
    total: 0,
    list: [],
    isSearch: false,
    captchUrl: "",
    form: {},
  },

  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total;
    },
    SET_LIST: (state, list) => {
      state.list = list;
    },
    SET_ISSEARCH: (state, isSearch) => {
      state.isSearch = isSearch;
    },
    SET_CAPTCHURL: (state, url) => {
      state.captchUrl = url;
    },
    SET_FORM: (state, form) => {
      state.form = form;
    },
  },

  actions: {
    getList({ commit }, params) {
      return new Promise((resolve, reject) => {
        patentSearch(params)
          .then((res) => {
            resolve(res);
            commit("SET_TOTAL", res.data.rows);
            commit("SET_LIST", res.data.total);
            commit("SET_ISSEARCH", true);
          })
          .catch((error) => {
            reject(error);
            // 刷新验证码
            commit("SET_ISSEARCH", false);
          });
      });
    },
    // 获取验证码
    getCaptcha({ commit }) {
      getCaptcha().then((res) => {
        let base64Data = btoa(
          new Uint8Array(res).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        );
        commit("SET_CAPTCHURL", `data:image/png;base64,${base64Data}`);
      });
    },
  },
};

export default search;
